import studentGallery from '@/api/student-gallery'
import classOperation from '@/api/class-operation'
import Enrollment from '@/api/student-enrollment'
import { baseState, baseMutations } from '@/store/mixins'
import moment from 'moment'

export const state = {
  ...baseState,
  ac_status_id: 1,
  date_from: moment()
    .startOf('month')
    .format('DD-MM-YYYY'),
  date_to: moment()
    .endOf('month')
    .format('DD-MM-YYYY')
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_DATE_FROM(state, data) {
    state.date_from = data
  },
  SET_DATE_TO(state, data) {
    state.date_to = data
  },
  SET_AC_STATUS(state, acStatusId) {
    state.ac_status_id = acStatusId
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        date_range: [context.state.date_from, context.state.date_to]
      },
      attrubutes
    )
    return studentGallery.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return studentGallery.store(data)
  },
  //download specify photo
  download(context, id) {
    return studentGallery.download(id)
  },
  //delete specify photo
  removePhoto(context, id) {
    return studentGallery.removePhoto(id)
  },
  removeFileUploaded(context, attributes) {
    return studentGallery.removeFile({
      params: attributes
    })
  },
  update(context, data) {
    return studentGallery.update(data)
  },
  destroy(context, id) {
    return studentGallery.destroy(id)
  },
  // Get Student Enrollment by Class
  getStudentEnrollmentByClass(context, class_id) {
    return Enrollment.get({
      params: {
        include: 'student_profile',
        fields: {
          academic_student_to_classes: 'class_id,student_id,teacher_resp_id',
          student_profile: 'student_id,card_number,first_name_en,last_name_en'
        },
        filter: {
          class_id: class_id
        },
        page: -1
      }
    })
  },
  // Get Class Operation
  getClassOperation(context) {
    return classOperation.get({
      params: {
        include: 'teacher',
        fields: {
          academic_classes: 'class_id,class_name,teacher_resp_id',
          teacher: 'teacher_id,fname_foreign,lname_foreign'
        },
        filter: {
          ac_status_id: context.state.ac_status_id
        },
        page: -1
      },
      header: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  viewPhoto(context, uploadId) {
    let params = Object.assign(
      {
        perPage: uploadId.perPage,
        page: uploadId.page,
        upload_id: uploadId.upload_id
      },
    )
    return studentGallery.viewPhoto({ params })
  },
  storeViewUpload(context, data) {
    return studentGallery.storeViewUpload(data)
  }
}
